import React, { Fragment } from 'react';

import { notNullish } from '@paragon/utilities';

import { useAppSelector } from '../../../components/hooks';
import { getCommittedComponentDesigns } from '../../../store/selectors/getComponentDesignsSelectors';
import { getVisibleDesignedEnvelopes } from '../../../store/selectors/layoutDataSelectors';
import { getAllTrussEnvelopePositions } from '../../../store/selectors/layoutDocumentSelectors';
import { getActiveConnectionMode, getActiveEnvelopeMode } from '../../../store/selectors/layoutVisualOptionsSelectors';
import { useAutoInvalidateOnChange } from '../../hooks/invalidation-hooks';
import { HangerVisual } from '../HangerVisual';

export function LayoutConnectingHardwareController() {
  const trussEnvelopes = useAppSelector(getVisibleDesignedEnvelopes);
  const envelopeMatrices = useAppSelector(getAllTrussEnvelopePositions);
  const componentDesigns = useAppSelector(getCommittedComponentDesigns);

  const envelopeMode = useAppSelector(getActiveEnvelopeMode);
  const connectionsMode = useAppSelector(getActiveConnectionMode);

  useAutoInvalidateOnChange(connectionsMode); // the envelopes controller will invalidate when connections are edited

  const shouldRenderHardware =
    envelopeMode === 'components' && (connectionsMode === 'hardware' || connectionsMode === 'hardwareAndConnections');

  if (!shouldRenderHardware) return null;

  return (
    <>
      {trussEnvelopes
        .map((envelope) => {
          const matrix = envelopeMatrices[envelope.guid];
          const componentDesign = envelope.componentDesignGuid
            ? componentDesigns.find((design) => design.guid === envelope.componentDesignGuid)
            : null;

          if (!matrix || !componentDesign) return null;

          return (
            <group key={envelope.guid} matrix={matrix} matrixAutoUpdate={false}>
              {componentDesign.component.hangers.map((hanger) => (
                <HangerVisual
                  mode="Layout"
                  key={hanger.guid}
                  hanger={hanger}
                  component={componentDesign.component}
                  numberOfPlies={envelope.numberOfPlies}
                />
              ))}
            </group>
          );
        })
        .filter(notNullish)}
    </>
  );
}
